export const UPDATE_CHATLOG_STATE = 'UPDATE_CHATLOG_STATE';
export const MESSAGE_TIME_SERIES_LOADING = 'MESSAGE_TIME_SERIES_LOADING';
export const MESSAGE_TIME_SERIES_LOAD_ERROR = 'MESSAGE_TIME_SERIES_LOAD_ERROR';
export const MESSAGE_TIME_SERIES_RECEIVED = 'MESSAGE_TIME_SERIES_RECEIVED';
export const TRAINING_MESSAGE_LOADING = 'TRAINING_MESSAGE_LOADING';
export const TRAINING_MESSAGE_LOAD_SUCCESS = 'TRAINING_MESSAGE_LOAD_SUCCESS';
export const TRAINING_MESSAGE_LOAD_ERROR = 'TRAINING_MESSAGE_LOAD_ERROR';
export const MESSAGE_TRAINING_START = 'MESSAGE_TRAINING_START';
export const MESSAGE_TRAINING_END = 'MESSAGE_TRAINING_END';
export const MESSAGE_TRAINING_SUCCESS = 'MESSAGE_TRAINING_SUCCESS';


// WEBPACK FOOTER //
// ./src/data/redux/chatlog_details/actiontypes.js